import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { DeserializedCompanyUser } from '@/src/lib/company-user/types';
import { Dictionary } from '@/src/lib/dictionary/types';
import { GetUser } from '@/src/lib/auth/types';
import { DeserializedCart } from '@/src/lib/cart/glue/types/deserialized';
import AccountCard from '@/src/app/components/Header/AccountCard/AccountCard';
import { DeserializedStore } from '@/src/lib/store/types';
export type AccountCardsProps = {
  dict: Dictionary;
  user: GetUser;
  companyUsers: Array<DeserializedCompanyUser>;
  cart?: DeserializedCart;
  lang: string;
  store: DeserializedStore;
};
function AccountCards(t0) {
  const $ = _c(15);
  const {
    dict,
    user,
    companyUsers,
    cart,
    lang,
    store
  } = t0;
  let t1;
  if ($[0] !== cart || $[1] !== companyUsers || $[2] !== dict || $[3] !== lang || $[4] !== store || $[5] !== user) {
    let t2;
    if ($[7] !== cart || $[8] !== dict || $[9] !== lang || $[10] !== store || $[11] !== user) {
      t2 = companyUser => <AccountCard dict={dict} user={user} companyUser={companyUser} key={companyUser.id} cart={cart} lang={lang} store={store} />;
      $[7] = cart;
      $[8] = dict;
      $[9] = lang;
      $[10] = store;
      $[11] = user;
      $[12] = t2;
    } else {
      t2 = $[12];
    }
    t1 = companyUsers.map(t2);
    $[0] = cart;
    $[1] = companyUsers;
    $[2] = dict;
    $[3] = lang;
    $[4] = store;
    $[5] = user;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[13] !== t1) {
    t2 = <div className="flex flex-col gap-7" data-testid="account-modal">{t1}</div>;
    $[13] = t1;
    $[14] = t2;
  } else {
    t2 = $[14];
  }
  return t2;
}
export default AccountCards;